const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.backgroundProvider.';

const STAY_ONBOARDING = `${DOMAIN}stayOnboardingButton`,
  DECLINE_ONBOARDING = `${DOMAIN}backToAmazonButton`;

export { DECLINE_ONBOARDING, STAY_ONBOARDING };
